module.exports = __webpack_public_path__ + "assets/fusioncharts.f2f0b0c8.svg";